/** Environment site ids currently assigned to the template lineage (any environment). */
export function getAssignedEnvironmentSiteIds(assignments, consentTemplateKey) {
    return assignments.filter((a) => a.consentTemplateKey === consentTemplateKey).map((a) => a.environmentSiteId);
}
/** Consent template keys currently assigned to the environment site. */
export function getAssignedConsentTemplateKeys(assignments, environmentSiteId) {
    return assignments.filter((a) => a.environmentSiteId === environmentSiteId).map((a) => a.consentTemplateKey);
}
